import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../config/firebase';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose, userRole }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const allMenuItems = [
    {
      id: 'depense',
      label: 'Dépenses',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="12" y1="1" x2="12" y2="23" />
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
      ),
      path: '/admin/depense',
      rolesOnly: [2]
    },
    {
      id: 'reservations',
      label: 'Réservations',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
          <polyline points="17 21 17 13 7 13 7 21" />
          <polyline points="7 3 7 8 15 8" />
        </svg>
      ),
      path: '/admin',
      pathRole2: '/admin/reservations'
    },
    {
      id: 'revenue',
      label: 'Dashboard Revenus',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="12" y1="2" x2="12" y2="22" />
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
      ),
      path: '/admin/revenue'
    },
    {
      id: 'analytics',
      label: 'Google Analytics',
      badge: 'BETA',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 3v18h18" />
          <path d="M18 7l-5 5-4-4-3 3" />
        </svg>
      ),
      path: '/admin/analytics'
    },
    {
      id: 'fixedCharges',
      label: 'Fixed Charges',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
          <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01" />
        </svg>
      ),
      path: '/admin/fixed-charges'
    },
    {
      id: 'reviews',
      label: 'Avis Google Maps',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          <path d="M12 8v4" />
          <path d="M12 16h.01" />
        </svg>
      ),
      path: '/admin/reviews',
      requireRole: 0 // Seulement pour role === 0
    },
    {
      id: 'revenue-upload',
      label: 'Upload Revenus',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17 8 12 3 7 8" />
          <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
      ),
      path: '/admin/revenue-upload',
      requireRole: 0 // Seulement pour role === 0
    },
    {
      id: 'blocked-slots',
      label: 'Créneaux Désactivés',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
          <line x1="8" y1="14" x2="8" y2="14" />
          <line x1="12" y1="14" x2="12" y2="14" />
          <line x1="16" y1="14" x2="16" y2="14" />
        </svg>
      ),
      path: '/admin/blocked-slots'
    },
    {
      id: 'ramadan-menu',
      label: 'Menu Ramadan',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M4 19.5A4.5 4.5 0 0 0 8.5 24c6.5 0 11.5-5 11.5-11.5S15 1 8.5 1A7.5 7.5 0 0 0 4 19.5z" />
          <path d="M12 7h0" />
        </svg>
      ),
      path: '/admin/ramadan-menu',
      requireRole: 0
    },
    {
      id: 'depense-all',
      label: 'Dépenses',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="12" y1="1" x2="12" y2="23" />
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
      ),
      path: '/admin/depense',
      hideForRole: 2
    }
  ];

  const menuItems = allMenuItems.filter(item => {
    if (userRole === 2) {
      return item.rolesOnly?.includes(2) || (item.pathRole2 && item.id === 'reservations');
    }
    if (item.hideForRole === userRole) return false;
    if (item.requireRole !== undefined) {
      return userRole === item.requireRole;
    }
    if (item.rolesOnly) return false;
    return true;
  }).map(item => {
    if (userRole === 2 && item.pathRole2) {
      return { ...item, path: item.pathRole2 };
    }
    return item;
  });

  const handleNavigation = (path) => {
    navigate(path);
    if (onClose) onClose();
  };

  const handleLogout = async () => {
    await signOut(auth);
    if (onClose) onClose();
  };

  const isActive = (path) => {
    if (path === '/admin') {
      return location.pathname === '/admin';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <>
      {/* Overlay pour mobile */}
      {isOpen && <div className={`sidebar-overlay ${isOpen ? 'active' : ''}`} onClick={onClose} />}
      
      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>Aqua Farina</h2>
          <button className="sidebar-close-btn" onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className={`sidebar-item ${isActive(item.path) ? 'active' : ''}`}
              onClick={() => handleNavigation(item.path)}
            >
              <span className="sidebar-icon">{item.icon}</span>
              <span className="sidebar-label">{item.label}</span>
              {item.badge && (
                <span className="sidebar-badge">{item.badge}</span>
              )}
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="sidebar-item sidebar-logout-btn" onClick={handleLogout}>
            <span className="sidebar-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
            </span>
            <span className="sidebar-label">Déconnexion</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;

